module.exports = __webpack_public_path__ + "media/images/symbol-defs-ad73aa09f8898abb5ff949a2e679bc9f.svg";